module.exports = __webpack_public_path__ + "static/media/custom_icon.e9ee0033.png";